import {zodResolver} from '@hookform/resolvers/zod';
import LoginIcon from '@mui/icons-material/Login';
import {Box, Button, Stack} from '@mui/material';
import {RhfTextField} from 'mui-rhf-integration';
import type * as React from 'react';
import {FormProvider, useForm} from 'react-hook-form';
import {useTranslation} from 'react-i18next';
import ReactMarkdown from 'react-markdown';
import {z} from 'zod';
import {useNotice} from '../Providers/NoticeProvider';

const schema = z.object({
    username: z.string(),
    password: z.string(),
});

type SignInFormSchemaType = z.infer<typeof schema>;

type Props = {
    handleSignInSubmit: (values: SignInFormSchemaType) => void;
};

const SignInForm = ({handleSignInSubmit}: Props): React.ReactElement => {
    const {t} = useTranslation();
    const [notice] = useNotice();

    const initialValues = {
        username: '',
        password: '',
    };

    const form = useForm<SignInFormSchemaType>({
        defaultValues: initialValues,
        resolver: zodResolver(schema),
    });

    return (
        <FormProvider {...form}>
            <form onSubmit={form.handleSubmit(handleSignInSubmit)}>
                <Stack spacing={2} sx={{mt: 2, mb: 3}}>
                    <Box sx={{textAlign: 'center', fontWeight: 600}}>{t('sefAdminSignIn')}</Box>
                    <ReactMarkdown className='markdown'>{notice.logInMessage}</ReactMarkdown>
                    <RhfTextField name={'username'} label={'Username'} control={form.control} />
                    <RhfTextField
                        name={'password'}
                        type={'password'}
                        label={'Password'}
                        control={form.control}
                    />
                    <hr />
                    <Stack sx={{flexDirection: 'row', justifyContent: 'flex-end'}}>
                        <Button
                            type={'submit'}
                            color={!form.formState.isValid ? 'error' : 'secondary'}
                            variant='outlined'
                            disabled={form.formState.isLoading || !form.formState.isValid}
                        >
                            {t('adminLogin')} &nbsp;
                            <LoginIcon />
                        </Button>
                    </Stack>
                </Stack>
            </form>
        </FormProvider>
    );
};

export default SignInForm;
